import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { Message } from "primeng/message";

export type Kno2AlertSeverity = "success" | "info" | "warn" | "error";

@Component({
    selector: "kno2-alert",
    imports: [Message],
    templateUrl: "./alert.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {
    public readonly closable = input(true);
    public readonly status = input<Kno2AlertSeverity>("info");
    public readonly message = input<string>();
    public readonly closeClick = output<void>();

    protected readonly title: Record<Kno2AlertSeverity, string> = {
        success: "Success!",
        info: "Notice!",
        warn: "Warning!",
        error: "Oh no!"
    };

    public onClose(): void {
        this.closeClick.emit();
    }
}
